import { render, staticRenderFns } from "./arrow-icon.vue?vue&type=template&id=56f79b38"
import script from "./arrow-icon.vue?vue&type=script&lang=js"
export * from "./arrow-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports